type ExternalLinkProps = {
  url: string;
  text: string;
  icon?: JSX.Element;
  isOnDarkBg?: boolean;
};

export default function ExternalLink({
  url,
  text,
  icon,
  isOnDarkBg,
}: ExternalLinkProps): JSX.Element {
  return (
    <a
      href={url}
      className={`${
        isOnDarkBg ? "text-ldir-blue-100" : "text-ldir-brown-900"
      } flex justify-between py-5 px-4 border-t border-ldir-blue-pale text-lg items-center`}
      target="_blank"
      rel="noreferrer"
    >
      <div className="flex items-center">
        <div className="mr-2">{icon}</div>
        {text}
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        role="graphics-symbol"
      >
        <path
          d="M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H12V2.66667H2.66667V21.3333H21.3333V12H24V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM8.93333 16.9333L7.06667 15.0667L19.4667 2.66667H14.6667V0H24V9.33333H21.3333V4.53333L8.93333 16.9333Z"
          fill="#006178"
        />
      </svg>
    </a>
  );
}
